export interface BasicTextSelection {
  all: boolean;
  values: string[];
}

export function isTextValueSelected(selection: BasicTextSelection, value: string): boolean {
  return selection.all ? !selection.values.includes(value) : selection.values.includes(value);
}

export function toggleTextValue(selection: BasicTextSelection, value: string, checked: boolean): BasicTextSelection {
  const remember = selection.all ? !checked : checked;
  return { all: selection.all, values: remember ? [...new Set([...selection.values, value])] : selection.values.filter((v) => v !== value) };
}

export function basicTextFilter(field: string, selection: BasicTextSelection) {
  return { field, operator: selection.all ? "not_in" : "in", value: [...selection.values] };
}
